import React from 'react'
import {
    Bloc,
    BlocConseilExpert,
    BlocIntField,
    BlocLoading,
    BlocResultat,
    BlocResultatCapaciteMaxEmprunt,
    Button,
    Conditionnal,
    Header,
    ListingAlerts,
    Title,
} from '../ImportAll'

export default function Vue21() {
    return (
        <div>
            <Conditionnal
                linked_data_id="tech_enr_dossier_status"
                isEqualTo
                targetDataValueCompare="LOAD"
            >
                <Header
                    title="Vous recherchez un crédit immobilier pour votre projet"
                    subTitle="Envoi en cours des données..."
                />
                <div className="Container">
                    <BlocResultat key="key163" simuler load />
                </div>
            </Conditionnal>
            <Conditionnal
                linked_data_id="tech_enr_dossier_status"
                isEqualTo
                targetDataValueCompare="SEND"
            >
                <Conditionnal
                    linked_data_id="prj_maturite"
                    isEqualTo
                    targetDataValueCompare="RECHERCHE"
                >
                    <Header
                        title="Vous recherchez un crédit immobilier pour votre projet"
                        subTitle="Résultat de votre simulation"
                    />
                    <div className="Container">
                        <Conditionnal
                            linked_data_id="tech_affichage_max_emp"
                            isEqualTo
                            targetDataValueCompare="OK"
                        >
                            <BlocResultatCapaciteMaxEmprunt infobulle="mensualité tout compris, assurances comprises" />
                            <ListingAlerts linked_list_id="resultat_evaluation_alerts" />
                        </Conditionnal>
                        <Conditionnal
                            linked_data_id="tech_affichage_max_emp"
                            isNotEqualTo
                            targetDataValueCompare="OK"
                        >
                            <BlocLoading message_principal="Actualisation des résultats" />
                        </Conditionnal>
                    </div>
                    <div className="Container">
                        <Title maintitle="Durée souhaitée du prêt" />
                        <Bloc
                            key="keye115"
                            selectable
                            linked_data_id="finance_duree_souhaite"
                            linked_data_value={60}
                            nbcolumn={3}
                            gauche
                            simpleDoubleWord
                            text1="5"
                            text2="ans"
                            height={80}
                        />
                        <Bloc
                            key="keye116"
                            selectable
                            linked_data_id="finance_duree_souhaite"
                            linked_data_value={120}
                            nbcolumn={3}
                            milieu
                            simpleDoubleWord
                            text1="10"
                            text2="ans"
                            height={80}
                        />
                        <Bloc
                            key="keye117"
                            selectable
                            linked_data_id="finance_duree_souhaite"
                            linked_data_value={180}
                            nbcolumn={3}
                            droit
                            simpleDoubleWord
                            text1="15"
                            text2="ans"
                            height={80}
                        />
                        <Bloc
                            key="keye118"
                            selectable
                            linked_data_id="finance_duree_souhaite"
                            linked_data_value={240}
                            nbcolumn={3}
                            gauche
                            simpleDoubleWord
                            text1="20"
                            text2="ans"
                            height={80}
                        />
                        <Conditionnal
                            linked_data_id="prj_usage"
                            isEqualTo
                            targetDataValueCompare="RES_PRINCIPALE"
                        >
                            <Bloc
                                key="keye119"
                                selectable
                                linked_data_id="finance_duree_souhaite"
                                linked_data_value={300}
                                nbcolumn={3}
                                milieu
                                simpleDoubleWord
                                text1="25"
                                text2="ans"
                                height={80}
                            />
                        </Conditionnal>
                    </div>

                    <div className="Container">
                        <BlocIntField
                            key="key1d14"
                            nbcolumn={1}
                            linked_data_id="finance_apport"
                            symbole=" €"
                            label="Montant de l’apport"
                            placeholder="Ex : 42 000 €"
                        />
                        <div className="SubmitButtonContainer">
                            {' '}
                            <Button
                                text="Actualiser"
                                ActualiserResultatMaxEmpruntable
                            />{' '}
                        </div>
                    </div>

                    <Conditionnal
                        linked_data_id="tech_immo_id_apporteur"
                        isNotEqualTo
                        targetDataValueCompare={30}
                    >
                        <Conditionnal
                            linked_data_id="resultat_affected_calendly"
                            isNotEmpty
                        >
                            <div className="Container">
                                <Title maintitle="Je profite" />
                                <BlocConseilExpert />
                            </div>
                        </Conditionnal>
                    </Conditionnal>
                </Conditionnal>

                <Conditionnal
                    linked_data_id="prj_maturite"
                    isEqualTo
                    targetDataValueCompare="TROUVE"
                >
                    <Header
                        title="Vous recherchez un crédit immobilier pour votre projet"
                        subTitle="Données envoyées avec succès"
                    />
                    <div className="Container">
                        <BlocResultat key="key163" simuler send />
                    </div>
                </Conditionnal>
            </Conditionnal>
            <Conditionnal
                linked_data_id="tech_enr_dossier_status"
                isEqualTo
                targetDataValueCompare="ERR"
            >
                <Header
                    title="Vous recherchez un crédit immobilier pour votre projet"
                    subTitle="Données non envoyées"
                />
                <div className="Container">
                    <BlocResultat key="key163" simuler err />
                </div>
            </Conditionnal>
        </div>
    )
}
